const RupiahConvert = value => {

  const convertToRupiah = () => {
    let rupiah = ''
    const convert = value.toString().split('').reverse().join('')

    for(var i = 0; i < convert.length; i++) if(i%3 === 0) rupiah += convert.substr(i,3)+'.'

    return 'Rp. '+rupiah.split('',rupiah.length-1).reverse().join('');
  }

  const convertToNumber = () => {
    return parseInt(value.replace(/,.*|[^0-9]/g, ''), 10)
  }

  const getWithComa = (number) => {
    const convertToNumber = parseFloat(number);
    const checkConvert =
      convertToNumber === NaN ? 0 : parseFloat(String(convertToNumber));

    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(checkConvert);
  };


  return {
    detail: convertToRupiah(),
    default: convertToNumber(),
    getWithComa: getWithComa(value),
  }
}

export default RupiahConvert